import { render } from "./ReferFriendPage.vue?vue&type=template&id=608243fc"
import script from "./ReferFriendPage.vue?vue&type=script&lang=js"
export * from "./ReferFriendPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__